const $         = require('jquery');
const bounds    = require('binary-search-bounds');
const { icon }  = require('@fortawesome/fontawesome-svg-core');
const tippy     = require('tippy.js/dist/tippy-bundle.umd.js');
const eventer   = require('../util/eventer');

const faIconOpts = { classes: ['fa-icon icon-h-16'] };

function Tabs() {
  const api     = eventer({});
  const tabs    = {};
  const sorted  = [];
  const elem    = $(`
    <div class="tabs">
      <div class="tab-header">
        <div class="tab-title"></div>
        <ul></ul>
      </div>
      <div class="tab-content"></div>
    </div>
  `);

  let activeId = '';
  let activeView = null;

  function init(parent) {
    elem.appendTo(parent);
  }

  function select(id) {
    if (id === activeId) return;
    activeId = id;

    const header = elem.find(`.tab-header > ul > li[tab-id="${id}"]`);
    const content = elem.find(`.tab-content > div[tab-id="${id}"]`);
    activeView = tabs[id].render();

    elem.find(`.tab-header > ul > li`).removeClass('active');
    elem.find(`.tab-content > div`).removeClass('active');
    elem.find(`.tab-title`).text(tabs[id].title);

    header.addClass('active');
    content.addClass('active');

    activeView.appendTo(content);
    activeView.trigger('attached');
    activeView.trigger('activate');
    api.trigger('tab-selected', [activeId]);
  }

  function deselect() {
    elem.find(`.tab-header > ul > li`).removeClass('active');
    elem.find(`.tab-content > div`).removeClass('active');
    elem.find(`.tab-title`).text('');
    activeId = '';
    if (activeView) {
      activeView.trigger('deactivate');
      activeView = null;
    }
  }

  function get(id) {
    return tabs[id];
  }

  function add(tab) {
    tabs[tab.id] = tab;

    if (isNaN(parseInt(tab.index))) {
      tab.index = sorted.length ? (sorted[sorted.length - 1].index + 1) : 1;
    }

    elem.toggleClass('single-tab', Object.keys(tabs).length <= 1);

    const header = $(`
      <li tab-id="${tab.id}" tab-index="${tab.index}">
        <button data-tippy-content="${tab.title}">
          ${icon(tab.icon, faIconOpts).html}
        </button>
      </li>
    `);
    const button = header.find('button');
    const content = $(`<div tab-id="${tab.id}"></div>`);

    const start = bounds.ge(sorted, tab, (a, b) => a.index - b.index);
    if (sorted[start]) {
      header.insertBefore(elem.find(`.tab-header > ul > li[tab-index="${sorted[start].index}"]`));
      sorted.splice(start, 0, tab);
    } else {
      header.appendTo(elem.find('.tab-header > ul'));
      sorted.push(tab);
    }
    content.appendTo(elem.find('.tab-content'));

    header.click(() => select(tab.id));

    tippy(button[0], { placement: 'bottom' });

    api.trigger('tab-added', [tab.id]);
  }

  function remove(id) {
    select(sorted[0].id);
    elem.find(`.tab-header > ul > li[tab-id="${id}"]`).remove();
    elem.find(`.tab-content > div[tab-id="${id}"]`).remove();
    delete tabs[id];
    elem.toggleClass('single-tab', Object.keys(tabs).length <= 1);
  }

  api.init = init;
  api.get = get;
  api.add = add;
  api.remove = remove;
  api.select = select;
  api.deselect = deselect;
  api.sorted = () => sorted;

  Object.defineProperty(api, 'activeId', {
    get() { return activeId; }
  });

  return api;
}

module.exports = Tabs;
